import { Handshake, ArrowUpRight } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { goToEnquiryAs } from "@/components/EnquiryForm";

// Click-triggered (via the "Become A Dealer" badge in the Wellside
// Canopies hero) — covers both dealer/installer enquiries AND fleet/trade
// buyers in one modal, since both ultimately want the same next step: get
// in touch. The CTA presets the footer enquiry form's Product Interest
// dropdown and scrolls straight to it.
export const WellsideDealerFleetModal = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="wellside-dealer-fleet-modal" className="max-w-lg bg-[var(--bg-secondary)] border-[var(--border-default)] text-white">
      <DialogHeader>
        <div className="w-11 h-11 flex items-center justify-center border border-[var(--brand-primary)] bg-[var(--brand-primary)]/15 mb-2">
          <Handshake size={20} className="text-[var(--brand-primary)]" />
        </div>
        <DialogTitle className="font-display text-2xl text-white">Become A Dealer, Or Buying For A Fleet?</DialogTitle>
        <DialogDescription className="text-base text-[var(--text-secondary)] leading-relaxed">
          Whether you want to become a Bushtech dealer and install our canopies for customers,
          or you need multiple canopies for a fleet with trade pricing and ongoing supply — we'd
          love to hear from you. Tell us what you need below.
        </DialogDescription>
      </DialogHeader>
      <button
        type="button"
        data-testid="wellside-dealer-fleet-cta"
        onClick={() => {
          onOpenChange(false);
          goToEnquiryAs("Dealer / Trade / Fleet Enquiry");
        }}
        className="btn-primary justify-self-start"
      >
        Get In Touch <ArrowUpRight size={14} />
      </button>
    </DialogContent>
  </Dialog>
);
